export enum SubsectorIdentifier {
  PRIVATE_TRANSPORT = 0,
  FREIGHT_TRANSPORT = 1,
  OTHER_TRANSPORT = 2,
  CEMENT_AND_CONCRETE = 3,
  IRON_AND_STEEL = 4,
  CHEMICAL = 5,
  METALS = 6,
  OTHER_INDUSTRY = 7,
  PAPER = 8,
  REFINERIES = 9,
  ANIMAL_DIGESTION = 10,
  AGRICULTURAL_LAND = 11,
  STORAGE_OF_FERTILISERS = 12,
  ELECTRICITY_AND_DISTRICT_HEATING = 13,
  LOCAL_HEATING = 14,
  MACHINERY = 15,
  WASTE = 16,
  SOLVENTS = 17,
  LOCAL_HEATING_RESIDENTIAL = 18,
  LOCAL_COOLING_RESIDENTIAL = 19,
  LOCAL_COOLING = 20,
  LOCAL_OTHER = 21,
  LOCAL_OTHER_RESIDENTIAL = 22,
}
